import {useEffect} from "react";
import {usePage} from "@inertiajs/react";
import isEmpty from "is-empty";
import {useModalStore} from "@/Stores/Site/ModalStore";

let timerGiftCalendar = null;

export default function useShowGiftCalendar() {
    const {props} = usePage();
    const {mobileApp = false, giftCalendar = false} = props;

    const openGiftCalendarModal = useModalStore(state => state.openGiftCalendarModal);

    useEffect(() => {
        /**
         * Очистка таймера если был установлен ранее
         */
        if (timerGiftCalendar) {
            clearTimeout(timerGiftCalendar);
        }

        /**
         * Проходим далее если:
         * 1. Если не на странице календаря
         * 2. Если действует акция (определяет сервер)
         * 3. Если запущен таймер
         * 4. Окно показывается впервые
         * 5. Если открыли не из приложения
         */
        if (
            location.pathname === '/advent-calendar' ||
            !giftCalendar ||
            timerGiftCalendar ||
            !isEmpty(sessionStorage.getItem('giftCalendar')) ||
            mobileApp
        ) {
            return;
        }

        timerGiftCalendar = setTimeout(() => {
            openGiftCalendarModal(); // Показываем модальное окно "Весенний календарь подарков"
        }, 30000); // 30 секунд = 30000 миллисекунд
    }, []);
}
